// extracted by mini-css-extract-plugin
export default {"spinner":"spinner__mtent","tooltip":"tooltip__hHWgI"};